import { render, staticRenderFns } from "./formulaShop.vue?vue&type=template&id=78cf2bd0&scoped=true"
import script from "./formulaShop.vue?vue&type=script&lang=js"
export * from "./formulaShop.vue?vue&type=script&lang=js"
import style0 from "./formulaShop.vue?vue&type=style&index=0&id=78cf2bd0&prod&lang=scss&scoped=true"
import style1 from "./formulaShop.vue?vue&type=style&index=1&id=78cf2bd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cf2bd0",
  null
  
)

export default component.exports